export enum MiniPopupPosition {
  Top,
  Center
}
